export const civilizationList = [
  {
    title: '客户至上',
    describe: '以热诚的态度及高专业水准服务客户，与客户为友，相互学习共同成长'
  },
  {
    title: '以人为本',
    describe: '融合中西文化，从上至下以身作则，彼此尊重包容，人人充满自豪感与成就感'
  },
  {
    title: '鼓励创新',
    describe: '持续提升服务能力，鼓劢开拓创新，将科技融入并驱动业务发展'
  },
  {
    title: '协作共进',
    describe: '建立和谐奋进的工作氛围，每个人都敢于承担责任，各展其能，积极有序高效推进'
  }
]

export const attestationList = [
  {
    title: '国家信息安全',
    describe: '等级保护三级'
  },
  {
    title: 'ISO27001',
    describe: '信息安全管理体系认证'
  },
  {
    title: 'ISO9001',
    describe: '质量管理体系认证'
  },
  {
    title: 'ISO20000',
    describe: '信息技术服务管理体系认证'
  },
  {
    title: 'ISO27701',
    describe: '隐私管理体系认证'
  },
  {
    title: 'CMMI3',
    describe: '软件能力成熟度模型等级认证'
  },
  {
    title: '软件企业认证',
    describe: '软件产品认证'
  }
]

export const authorityList = [
  {
    key: '1',
    path: 'http://www.chinatax.gov.cn/'
  },
  {
    key: '2',
    path: 'http://www.mof.gov.cn/index.htm'
  },
  {
    key: '3',
    path: 'http://www.customs.gov.cn/'
  },
  {
    key: '4',
    path: 'http://www.safe.gov.cn/'
  },
  {
    key: '5',
    path: 'https://www.ndrc.gov.cn/'
  },
  {
    key: '6',
    path: 'http://www.mofcom.gov.cn/'
  },
  {
    key: '7',
    path: 'https://www.un.org/zh/'
  },
  {
    key: '8',
    path: 'https://www.oecd.org/'
  },
  {
    key: '9',
    path: 'https://www.wto.org/'
  }
]

export const prizeList = [
  {
    year: '2023-2024',
    list: [
      '数央网年度“最具有成长价值奖”',
      '艾媒年度中国新经济未来独角兽百强企业',
      '入选“真榜2023·科技创新潜力独角兽TOP30”',
      '入选“第五届全球金融科技创业大赛”十强',
      '入选“中国信通院《高质量数字化转型产品及服务全景图》”'
    ]
  },
  {
    year: '2022',
    list: [
      '深圳软件行业“推荐优秀产品”',
      'CFS数字化先锋产品奖',
      '中国国际高新技术成果交易会“优秀产品”',
      'Venture50新芽榜150强',
      '入选艾瑞网“中国企业级SaaS行业”研究报告',
      '艾媒中国最佳数字化转型服务商',
      '入选《互联网周刊》联合德本咨询、eNet研究院共同发布的“企业财税服务创新排行榜”'
    ]
  },
  {
    year: '2021',
    list: [
      '入选腾讯SaaS加速器三期TOP45',
      '德勤深圳高科技明日之星',
      '易观之星“卓越数字化企业”',
      '国际科创节“年度数字化创新典范奖”',
      'WIM全球产业数字化服务商TOP40'
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/home/data.js